/**
 * Monedas disponibles para los negocios. Fuente única: antes cada modal de
 * negocio tenía su propia lista hardcodeada (DealsBoard y Contact360View), así
 * que agregar una moneda obligaba a acordarse de tocar los dos lugares.
 *
 * El código es ISO 4217 de 3 letras — la columna `currency` de la tabla deals
 * es string(3), así que no se pueden agregar códigos más largos sin migrar.
 */
export const CURRENCIES = [
    { code: 'USD', symbol: '$',   label: 'Dólar estadounidense' },
    { code: 'EUR', symbol: '€',   label: 'Euro' },
    { code: 'VES', symbol: 'Bs',  label: 'Bolívar venezolano' },
    { code: 'AED', symbol: 'د.إ', label: 'Dirham (EAU)' },
    { code: 'GBP', symbol: '£',   label: 'Libra esterlina' },
    { code: 'MXN', symbol: '$',   label: 'Peso mexicano' },
    { code: 'COP', symbol: '$',   label: 'Peso colombiano' },
    { code: 'ARS', symbol: '$',   label: 'Peso argentino' },
    { code: 'CLP', symbol: '$',   label: 'Peso chileno' },
    { code: 'PEN', symbol: 'S/',  label: 'Sol peruano' },
    { code: 'BRL', symbol: 'R$',  label: 'Real brasileño' },
    { code: 'DOP', symbol: 'RD$', label: 'Peso dominicano' },
    { code: 'PAB', symbol: 'B/.', label: 'Balboa panameño' },
    { code: 'CAD', symbol: '$',   label: 'Dólar canadiense' },
    { code: 'CHF', symbol: 'Fr',  label: 'Franco suizo' },
];

export const DEFAULT_CURRENCY = 'USD';

/** Etiqueta para el <option>: "USD ($) — Dólar estadounidense". */
export function currencyOptionLabel({ code, symbol, label }) {
    return `${code} (${symbol}) — ${label}`;
}

/**
 * Moneda por defecto del tenant, configurable en Configuración General.
 * Cae a USD si no está configurada o si quedó guardado un código que ya no
 * existe en la lista.
 */
export function tenantDefaultCurrency(tenant) {
    const configured = tenant?.settings?.default_currency;
    return CURRENCIES.some((c) => c.code === configured) ? configured : DEFAULT_CURRENCY;
}
